import { Column, Spinner } from 'hatch-components';
import React from 'react';
import styled from 'styled-components';

const StyledSpinnerWrapper = styled(Column)(() => ({
  alignItems: 'center',
  height: '100vh',
  justifyContent: 'center',
  width: '100vw',
}));

export const StyledSpinner = styled(Spinner)(() => ({
  height: 96,
  width: 96,
}));

const Loading = () => (
  <StyledSpinnerWrapper>
    <StyledSpinner color="#6515DD" />
  </StyledSpinnerWrapper>
);

export default Loading;
